module.exports = __webpack_public_path__ + "static/2-8a14fc206433c623bd009a3615242f1c.png";